import React, { useState } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import axios from 'axios';

const CreateMultiyatraBelt = ({ show, onHide }) => {
    const [formData, setFormData] = useState({
        title: '',
        category: '',
        status: 'Active',
        blessing_text: '',
        image: null,
        action_button_label: '',
        priority: '',
        action_link: '',
        display_start_date: '',
        display_end_date: '',
        display_time: '',
        frequency: '',
        image_only: 0
    });

    const [imagePreview, setImagePreview] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [charCount, setCharCount] = useState(0);
    const emojiPattern = /[\p{Emoji}]/u;

    const handleInputChange = (e) => {
        const { name, value, checked } = e.target;
        if ((name === 'title' || name === 'blessing_text')) {
            // Check if the new value has an emoji that wasn't in the previous value
            if (emojiPattern.test(value) && !emojiPattern.test(formData[name])) {
                toast.error('Emojis are not allowed in text fields');
                return;
            }
        }
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

// if (name === 'image_only') {
//     console.log("Toggling image_only", e.target.checked);
//             setFormData(prev => ({
//                 ...prev,
//                 [name]: checked  ? 1 : 0
//             }));
//         }

        // Update character count for blessing text
        if (name === 'blessing_text') {
            setCharCount(value.length);
        }
        if (name === 'category' && value === 'Live Aarti') {
            // When Live Aarti is selected, set current time as default
            setFormData(prev => ({
                ...prev,
                [name]: value,
                display_time: new Date().toTimeString().slice(0, 5) // Sets current time in HH:MM format
            }));
        } else if (name === 'category' && value !== 'Live Aarti') {
            // When switching away from Live Aarti, clear the time
            setFormData(prev => ({
                ...prev,
                [name]: value,
                display_time: ''
            }));
        } else {
            // Normal handling for other fields
           setFormData(prev => ({
                ...prev,
                [name]: name === 'image_only' ? (checked ? 1 : 0) : value // <-- THIS IS THE KEY FIX
            }));
        }
        if (name === 'display_start_date' || name === 'display_end_date') {
            const startDate = name === 'display_start_date' ? value : formData.display_start_date;
            const endDate = name === 'display_end_date' ? value : formData.display_end_date;

            // Only validate if both dates are selected
            if (startDate && endDate) {
                const start = new Date(startDate);
                const end = new Date(endDate);

                if (end < start) {
                    toast.error('End date cannot be earlier than start date');
                    return;
                }
            }
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check file size (max 3MB)
            if (file.size > 3 * 1024 * 1024) {
                toast.error('Image size should be less than 3MB');
                return;
            }

            // Check file type
           const fileType = file.type.toLowerCase();
if (!fileType.includes('jpeg') && !fileType.includes('jpg') && !fileType.includes('png') && !fileType.includes('webp')) {
    toast.error('Only JPG/PNG/WEBP files are allowed');
    return;
}

            setFormData(prev => ({
                ...prev,
                image: file
            }));

            // Create image preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting || isSubmitted) return;

        try {
            setIsSubmitting(true);

            // Validate required fields
            const requiredFields = [
                // { name: 'title', label: 'Title' },
                { name: 'category', label: 'Category' },
                // { name: 'blessing_text', label: 'Blessing Text' },
                { name: 'priority', label: 'Priority' },
                { name: 'display_start_date', label: 'Display Start Date' },
                { name: 'frequency', label: 'Frequency' },
                { name: 'action_link', label: 'Action link/URL' }
                
            ];

            for (const field of requiredFields) {
                if (!formData[field.name]) {
                    toast.error(`Please enter ${field.label}`);
                    setIsSubmitting(false);
                    return;
                }
            }

            // If action_link is provided, action_button_label is required
            // if (formData.action_link) {
            //     toast.error('Please select an Action Button Label when providing an Action Link');
            //     setIsSubmitting(false);
            //     return;
            // }

            if (!formData.image) {
                toast.error('Please upload an image');
                setIsSubmitting(false);
                return;
            }

            // Character limits
            if (formData.image_only === 0) {
            if (formData.title.length > 30) {
                toast.error('Title must be 30 characters or less');
                setIsSubmitting(false);
                return;
            }

            if (formData.blessing_text.length > 50) {
                toast.error('Blessing Text must be 50 characters or less');
                setIsSubmitting(false);
                return;
            }
        }
            // Special validation for Live Aarti category
            if (formData.category === 'Live Aarti' && !formData.display_time) {
                toast.error('Time is required for Live Aarti category');
                setIsSubmitting(false);
                return;
            }

            if (formData.display_start_date && formData.display_end_date) {
                const startDate = new Date(formData.display_start_date);
                const endDate = new Date(formData.display_end_date);

                if (endDate < startDate) {
                    toast.error('End date cannot be earlier than start date');
                    setIsSubmitting(false);
                    return;
                }
            }

            // Create data object directly (similar to artifacts approach)
            const templateData = {
                title: formData.title,
                category: formData.category,
                status: formData.status,
                blessing_text: formData.blessing_text,
                action_button_label: formData.action_button_label || null,
                priority: formData.priority,
                action_link: formData.action_link || null,
                display_start_date: formData.display_start_date,
                display_end_date: formData.display_end_date || null,
                display_time: formData.display_time || null,
                frequency: formData.frequency,
                image_only: formData.image_only
            };

            console.log("Submitting data:", templateData);

            // Handle image upload
            if (formData.image) {
                const reader = new FileReader();
                reader.readAsDataURL(formData.image);
                reader.onloadend = async () => {
                    const base64Data = reader.result.split(',')[1]; // Get base64 part after comma

                    // Add image data to template data
                    templateData.thumbnailContent = base64Data;
                    templateData.thumbnailType = formData.image.type;

                    try {
                        // Call API with data object
                        const response = await axios.post(`${ServerPath}/kuber-belt`, templateData);

                        if (response.data.success) {
                            setIsSubmitted(true);
                            toast.success('Template created successfully');
                            setTimeout(() => {
                                onHide();
                            }, 1500);
                        } else {
                            toast.error(response.data.message || 'Failed to create template');
                            setIsSubmitting(false);
                        }
                    } catch (apiError) {
                        console.error('API error:', apiError);
                        toast.error(apiError.response?.data?.message || 'Failed to create template');
                        setIsSubmitting(false);
                    }
                };

                reader.onerror = (error) => {
                    console.error('Error reading file:', error);
                    toast.error('Error processing image');
                    setIsSubmitting(false);
                };
            } else {
                // This block shouldn't normally be reached due to validation above
                const response = await axios.post(`${ServerPath}/kuber-belt`, templateData);

                if (response.data.success) {
                    setIsSubmitted(true);
                    toast.success('Template created successfully');
                    setTimeout(() => {
                        onHide();
                    }, 1500);
                    window.location.reload();
                } else {
                    toast.error(response.data.message || 'Failed to create template');
                    setIsSubmitting(false);
                }
            }
        } catch (error) {
            console.error('Error creating template:', error);
            toast.error(error.response?.data?.message || 'Failed to create template');
            setIsSubmitting(false);
        }
    };

    // Reset form when closing modal
    const handleClose = () => {
        setFormData({
            title: '',
            category: '',
            status: 'Active',
            blessing_text: '',
            image: null,
            action_button_label: '',
            priority: '',
            action_link: '',
            display_start_date: '',
            display_end_date: '',
            display_time: '',
            frequency: '',
            image_only: 0
        });
        setImagePreview(null);
        setIsSubmitting(false);
        setIsSubmitted(false);
        setCharCount(0);
        onHide();
    };

    // Category options
    const categoryOptions = [
        'Daily Blessing',
        'Festival',
        'Quote',
        'Promotion',
        'Live Aarti',
        'Ad'
    ];

    // Status options
    const statusOptions = [
        'Active',
        'Archive'
    ];

    // Frequency options
    const frequencyOptions = [
        'Once',
        'Daily',
        'Weekly',
        'Monthly',
        'Quarterly',
        'Half-Yearly',
        'Annually'
    ];

    // Action button label options
    const actionButtonOptions = [
        'Click Here',
        'Know More',
        'Read More',
        'Watch Now',
        'Live Darshan',
        'See Details',
        'Learn More',
        'Buy Now',
        'Donate Now',
        'Sponsor Pooja',
        'Talk to Guru',
        'Take Course',
        'Join Live',
        'Plan Your Trip'
    ];

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            centered
            style={{ borderRadius: '10px' }}
        >
            <div style={{ borderRadius: '10px' }}>
                <Modal.Header closeButton style={{ borderBottom: '1px solid #E2E8F0', padding: '20px 24px' }}>
                    <Modal.Title style={{ fontWeight: '600', fontSize: '22px' }}>Create Templates</Modal.Title>

                </Modal.Header>

                <Modal.Body style={{ padding: '36px' }}>
                    <Form>
                    <Row className="mb-3">
                            <Col md={6}>
                                <Form.Check
                                    type="checkbox"
                                    id="hasContainer"
                                    label="Image Only"
                                    name="image_only"
                                    checked={formData.image_only === 1 ? true : false}
                                    onChange={ handleInputChange}
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#4A5568'
                                    }}
                                                                            />
                            </Col>
                    </Row>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: formData.image_only === 1 ? '#8794abff':'#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Title <span className="text-danger">*</span>
                                        <span className="text-muted ms-2" style={{ fontSize: '12px' }}>
                                            (Character limit of 30 characters)
                                        </span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        placeholder="Enter Title"
                                        maxLength={30}
                                        disabled={formData.image_only === 1 ? true : false}
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Category <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="category"
                                        value={formData.category}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                    >
                                        <option value="" disabled>Select category</option>
                                        {categoryOptions.map((option, index) => (
                                            <option key={index} value={option}>{option}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Status <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="status"
                                        value={formData.status}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                    >
                                        <option value="" disabled>Select status</option>
                                        {statusOptions.map((option, index) => (
                                            <option key={index} value={option}>{option}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: formData.image_only === 1 ? '#8794abff':'#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Blessing Text <span className="text-danger">*</span>
                                        <span className="text-muted ms-2" style={{ fontSize: '12px' }}>
                                            (Character limit of 50 characters)
                                        </span>
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        name="blessing_text"
                                        value={formData.blessing_text}
                                        onChange={handleInputChange}
                                        placeholder="Enter Blessing Text"
                                        maxLength={50}
                                        disabled={formData.image_only === 1 ? true : false}
                                        style={{
                                            height: '150px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            resize: 'none'
                                        }}
                                    />
                                    <div className="text-end text-muted mt-1" style={{ fontSize: '12px' }}>
                                        {charCount}/50
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Upload <span className="text-danger">*</span>
                                    </Form.Label>
                                    <div
                                        style={{
                                            height: '150px',
                                            border: '1px dashed #E2E8F0',
                                            backgroundColor: '#F8F9FA',
                                            borderRadius: '6px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            position: 'relative',
                                            overflow: 'hidden'
                                        }}
                                        onClick={() => document.getElementById('imageUpload').click()}
                                    >
                                        {imagePreview ? (
                                            <img
                                                src={imagePreview}
                                                alt="Preview"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        ) : (
                                            <div className="text-center">
                                                <div style={{ fontSize: '24px', color: '#A0AEC0' }}>+</div>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            id="imageUpload"
                                            accept="image/jpeg,image/png,image/webp"
                                            onChange={handleImageChange}
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Action link/URL <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="action_link"
                                        value={formData.action_link}
                                        onChange={handleInputChange}
                                        placeholder="Enter Action link/URL"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            {/* {formData.action_link ? (
                                <>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                                Action Button Label <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="action_button_label"
                                                value={formData.action_button_label}
                                                onChange={handleInputChange}
                                                style={{
                                                    height: '46px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '6px',

                                                }}
                                            >
                                                <option value="" disabled>Select action button Label </option>
                                                {actionButtonOptions.map((option, index) => (
                                                    <option key={index} value={option}>{option}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                                Priority <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="priority"
                                                value={formData.priority}
                                                onChange={handleInputChange}
                                                placeholder="Enter Priority"
                                                min="1"
                                                max="10"
                                                style={{
                                                    height: '46px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '6px'
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </>
                            ) : ( */}
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Priority <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="priority"
                                            value={formData.priority}
                                            onChange={handleInputChange}
                                            placeholder="Enter Priority"
                                            min="1"
                                            max="10"
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            {/* )} */}
                        </Row>

                        <Row className="mb-3">
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Display Start Date <span className="text-danger">*</span>
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="date"
                                            name="display_start_date"
                                            value={formData.display_start_date}
                                            onChange={handleInputChange}
                                            min={new Date().toISOString().slice(0, 10)}
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px',
                                            }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Display End Date
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="date"
                                            name="display_end_date"
                                            value={formData.display_end_date}
                                            onChange={handleInputChange}
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px',
                                            }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                            {formData.category === 'Live Aarti' ? (
                                <>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                                Time <span className="text-danger">*</span>
                                            </Form.Label>
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="time"
                                                    name="display_time"
                                                    value={formData.display_time}
                                                    onChange={handleInputChange}
                                                    style={{
                                                        height: '46px',
                                                        border: '1px solid #E2E8F0',
                                                        backgroundColor: '#FFFFFF',
                                                        borderRadius: '6px',
                                                    }}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                                Frequency <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="frequency"
                                                value={formData.frequency}
                                                onChange={handleInputChange}
                                                style={{
                                                    height: '46px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '6px'
                                                }}
                                            >
                                                <option value="" disabled>Select frequency</option>
                                                {frequencyOptions.map((option, index) => (
                                                    <option key={index} value={option}>{option}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </>
                            ) : (
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Frequency <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            name="frequency"
                                            value={formData.frequency}
                                            onChange={handleInputChange}
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        >
                                            <option value="" disabled>Select frequency</option>
                                            {frequencyOptions.map((option, index) => (
                                                <option key={index} value={option}>{option}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            )}
                        </Row>
                    </Form>
                </Modal.Body>

                <div style={{ padding: '0 24px 24px 0', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={isSubmitting || isSubmitted}
                        style={{
                            backgroundColor: '#5662F6',
                            borderColor: '#5662F6',
                            borderRadius: '6px',
                            padding: '10px 40px',
                            fontWeight: '500',
                            fontSize: '16px'
                        }}
                    >
                        {isSubmitting ? 'Creating...' : 'Create'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default CreateMultiyatraBelt;